import api from '@/api';
import { PageRequest } from '@/core/request/PageRequest';
import { PageResult } from '@/core/request/PageResult';
import { API_BASE_URL } from '..';
import { Notification } from './Notification.types';

const baseUrl = `${API_BASE_URL}/notifications`;

export async function listNotifications(
  params?: PageRequest,
): Promise<PageResult<Notification>> {
  const result = (await api.get(`${baseUrl}/user`, params)) as unknown;

  return result as PageResult<Notification>;
}

export async function markReadNotification(notificationId: number) {
  const result = (await api.put(
    `${baseUrl}/${notificationId}`,
    {},
    null,
  )) as unknown;

  return result as Notification;
}

export async function deleteNotification(notificationId: number) {
  const result = (await api.remove(
    `${baseUrl}/${notificationId}`,
    {},
    null,
  )) as unknown;

  return result as Notification;
}
